import { render, staticRenderFns } from "./DialogDeleteItem.vue?vue&type=template&id=c72f4938&"
import script from "./DialogDeleteItem.vue?vue&type=script&lang=js&"
export * from "./DialogDeleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports